<template>
  <a @click="goToDetail" class="next-icon-link">
    <i class="ag-icon ag-icon_subtract next-icon"></i>
  </a>
</template>

<script setup>
import { defineProps, reactive } from 'vue'
import { useRoute, useRouter } from "vue-router";
const props = defineProps({
  data: Object,
});
const localData = reactive({ ...props.data });
const router = useRouter();
const routeName = useRoute().name;

if (routeName === 'templateAppGroupManagement') {
  const template = JSON.parse(localStorage.getItem("agms_template"));
  if (template?.mainid) {
    localData.templateId = template.mainid;
  }
}
  
const goToDetail = () => {
  router.push({
    path: localData.templateId != null ? `/administration/app-group-management/detail-role` :`/administration/app-group-management/detail`,
    query: {
      id: props.data?.id
    }
  });
};
</script>

<style scoped>
.next-icon {
  font-size: 1em !important;
}
.next-icon-link {
  cursor: pointer;
}
</style>
